import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadDriverLocations} from '../../actions/driverLocationActions';
import { withGoogleMap, GoogleMap, Marker, DirectionsRenderer, InfoWindow } from "react-google-maps";
import moment from 'moment';
import {BASE_URL} from '../../../src/constants';
import '../../assets/map_numbers/number_1.png';
import '../../assets/map_numbers/number_2.png';
import '../../assets/map_numbers/number_3.png';
import '../../assets/map_numbers/number_4.png';
import '../../assets/map_numbers/number_5.png';
import '../../assets/map_numbers/number_6.png';
import '../../assets/map_numbers/number_7.png';
import '../../assets/map_numbers/number_8.png';
import '../../assets/map_numbers/number_9.png';
import '../../assets/map_numbers/number_10.png';
import '../../assets/map_numbers/number_11.png';
import '../../assets/map_numbers/number_12.png';
import '../../assets/map_numbers/number_13.png';
import '../../assets/map_numbers/number_14.png';
import '../../assets/map_numbers/number_15.png';
import '../../assets/map_numbers/number_16.png';
import '../../assets/map_numbers/number_17.png';
import '../../assets/map_numbers/number_18.png';
import '../../assets/map_numbers/number_19.png';
import '../../assets/map_numbers/number_20.png';
import '../../assets/map_numbers/number_21.png';
import '../../assets/map_numbers/number_22.png';
import '../../assets/map_numbers/number_23.png';
import '../../assets/map_numbers/number_24.png';
import '../../assets/map_numbers/number_25.png';
import '../../assets/map_numbers/number_26.png';
import '../../assets/map_numbers/number_27.png';
import '../../assets/map_numbers/number_28.png';
import '../../assets/map_numbers/number_29.png';
import '../../assets/map_numbers/number_30.png';
import '../../assets/map_numbers/number_31.png';
import '../../assets/map_numbers/number_32.png';
import '../../assets/map_numbers/number_33.png';
import '../../assets/map_numbers/number_34.png';
import '../../assets/map_numbers/number_35.png';
import '../../assets/map_numbers/number_36.png';
import '../../assets/map_numbers/number_37.png';
import '../../assets/map_numbers/number_38.png';
import '../../assets/map_numbers/number_39.png';
import '../../assets/map_numbers/number_40.png';
import '../../assets/map_numbers/number_41.png';
import '../../assets/map_numbers/number_42.png';
import '../../assets/map_numbers/number_43.png';
import '../../assets/map_numbers/number_44.png';
import '../../assets/map_numbers/number_45.png';
import '../../assets/map_numbers/number_46.png';
import '../../assets/map_numbers/number_47.png';
import '../../assets/map_numbers/number_48.png';
import '../../assets/map_numbers/number_49.png';
import '../../assets/map_numbers/number_50.png';
import '../../assets/map_numbers/number_51.png';
import '../../assets/map_numbers/number_52.png';
import '../../assets/map_numbers/number_53.png';
import '../../assets/map_numbers/number_54.png';
import '../../assets/map_numbers/number_55.png';
import '../../assets/map_numbers/number_56.png';
import '../../assets/map_numbers/number_57.png';
import '../../assets/map_numbers/number_58.png';
import '../../assets/map_numbers/number_59.png';
import '../../assets/map_numbers/number_60.png';
import '../../assets/map_numbers/number_61.png';
import '../../assets/map_numbers/number_62.png';
import '../../assets/map_numbers/number_63.png';
import '../../assets/map_numbers/number_64.png';
import '../../assets/map_numbers/number_65.png';
import '../../assets/map_numbers/number_66.png';
import '../../assets/map_numbers/number_67.png';
import '../../assets/map_numbers/number_68.png';
import '../../assets/map_numbers/number_69.png';
import '../../assets/map_numbers/number_70.png';
import '../../assets/map_numbers/number_71.png';
import '../../assets/map_numbers/number_72.png';
import '../../assets/map_numbers/number_73.png';
import '../../assets/map_numbers/number_74.png';
import '../../assets/map_numbers/number_75.png';
import '../../assets/map_numbers/number_76.png';
import '../../assets/map_numbers/number_77.png';
import '../../assets/map_numbers/number_78.png';
import '../../assets/map_numbers/number_79.png';
import '../../assets/map_numbers/number_80.png';
import '../../assets/map_numbers/number_81.png';
import '../../assets/map_numbers/number_82.png';
import '../../assets/map_numbers/number_83.png';
import '../../assets/map_numbers/number_84.png';
import '../../assets/map_numbers/number_85.png';
import '../../assets/map_numbers/number_86.png';
import '../../assets/map_numbers/number_87.png';
import '../../assets/map_numbers/number_88.png';
import '../../assets/map_numbers/number_89.png';
import '../../assets/map_numbers/number_90.png';
import '../../assets/map_numbers/number_91.png';
import '../../assets/map_numbers/number_92.png';
import '../../assets/map_numbers/number_93.png';
import '../../assets/map_numbers/number_94.png';
import '../../assets/map_numbers/number_95.png';
import '../../assets/map_numbers/number_96.png';
import '../../assets/map_numbers/number_97.png';
import '../../assets/map_numbers/number_98.png';
import '../../assets/map_numbers/number_99.png';
import '../../assets/map_numbers/number_100.png';


const DirectionsGoogleMap = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={15}
    center={props.center}
    zoom={props.zoom}
    options={{fullscreenControl:true}}
  >
    {props.directions && <DirectionsRenderer
      directions={props.directions}
      options={{ suppressMarkers: true }}
    />}
    {props.markers && props.markers.map((marker, index) => (
      <Marker key={marker.key}
              {...marker}
              onClick={() => props.onMarkerClick(marker)}
      >
        {marker.showInfo && (
          <InfoWindow onCloseClick={() => props.onMarkerClose(marker)}>
            <div className="jumbotron">{marker.infoContent}</div>
          </InfoWindow>
        )}
      </Marker>
    ))}
  </GoogleMap>
));


class DriverLocationsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedDriverDate: '',
      markers: [],
      zoom: 18,
      center: {lat:-33.837578, lng:151.052963 },
      map: null,
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.loadLocations = this.loadLocations.bind(this);
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMapLoad = this.handleMapLoad.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);
  } 

  handleSelectChange(evnt) {
    evnt.preventDefault();
    let selectedValue = evnt.target.value;
    let filtered = this.props.driverLocations.items.filter(x => x.driverNameDate == selectedValue);

    if (selectedValue == '' || filtered.length <= 0 || filtered[0].locations.length==0) {
      this.setState({selectedDriverDate: '', markers: []});
      return;
    }

    let locations = filtered[0].locations;
    let bounds = new google.maps.LatLngBounds();

    let markers = locations.map((x, i) => {
      bounds.extend({lat: x.latitude, lng: x.longitude});
      return {
        location: x,
        position: {lat: x.latitude, lng: x.longitude},
        key: x.id,
        showInfo: false,
        infoContent: (<div className="container" style={{marginLeft: null, paddingLeft: null, paddingRight: null}}>
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <h3>Recorded driver location</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <strong>Driver: </strong>{x.driverFullName}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <strong>Pickup: </strong>{x.pickupLocationName ? x.pickupLocationName : 'Last known driver location'}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <strong>Date from/to: </strong>{moment(x.fromDate).format("dddd, MMMM Do YYYY, h:mm:ss a")} - {moment(x.toDate).format("h:mm:ss a")}
            </div>
          </div>
        </div>),
        icon: i < 100 ? `${BASE_URL}/assets/map_numbers/number_${i + 1}.png` : `//maps.google.com/mapfiles/ms/icons/pink-dot.png`
      };
    });

    this.setState({markers, center: markers[0].position, bounds}, ()=>{
      let {map, bounds} = this.state;
      if(map){
        map.fitBounds(bounds);
      }
    });
  }

  loadLocations(){
    this.props.dispatch(loadDriverLocations());
  }

  handleMapLoad(map){
    if(map){
      this.setState({map});
    }
  }

  handleMarkerClick(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        marker.showInfo = false;
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: true,
          };
        }
        return marker;
      })
    });
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: false,
          };
        }
        return marker;
      })
    });
  }

  componentDidMount(){
    this.loadLocations();
    window.scrollTo(0,0);
  }

  render() {
    let locations = this.props.driverLocations.items;
    if(!this.props.driverLocations.loaded){
      return (<div>
        <p>Loading... <i className="fa fa-cog fa-spin fa-2x" /></p>
      </div>);
    } else {
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <strong className="text-warning"><i className="fa fa-warning text-danger" /> List of most recent driver locations</strong>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-inline">
                { locations.length == 0 && <strong>No driver locations found&nbsp;&nbsp;</strong>}
                { locations.length > 0 &&
                <select className="form-control custom-select"
                        value={this.state.selectedDriverDate}
                        onChange={this.handleSelectChange}
                        name="driverLocationRuns">
                  <option value="" />
                  {locations.map(l => {
                    return (<option value={l.driverNameDate} key={l.driverNameDate}>{l.driverNameDate}</option>);
                  })}
                </select>
                  }
                <button className="btn btn-primary" onClick={this.loadLocations}><i className="fa fa-recycle"/> Reload</button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              &nbsp;
            </div>
          </div>
          <div className="row" ref="map">
            <div className="col-md-12">
              <DirectionsGoogleMap
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `800px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                onMapLoad={this.handleMapLoad}
                center={this.state.center}
                zoom={this.state.zoom}
                markers={this.state.markers}
                onMarkerClick={this.handleMarkerClick}
                onMarkerClose={this.handleMarkerClose}
              />
            </div>
          </div>
        </div>);
    }
  }
}

DriverLocationsPage.propTypes = {
  driverLocations: PropTypes.object.isRequired,
};

function mapStateToProps(state){
  return {
    driverLocations: state.driverLocations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverLocationsPage);
